import { render, staticRenderFns } from "./list.vue?vue&type=template&id=350a1b44&scoped=true&"
import script from "./list.js?vue&type=script&lang=js&"
export * from "./list.js?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=350a1b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a1b44",
  null
  
)

export default component.exports